// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"errorItem_wrapper_2hh_TXz"};